var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlinePresentionChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.9 17.75c-2.32 0-3.65-1.33-3.65-3.65V2c0-.41.34-.75.75-.75h18c.41 0 .75.34.75.75v12.1c0 2.32-1.33 3.65-3.65 3.65H5.9zM3.75 14.1c0 1.49.66 2.15 2.15 2.15h12.19c1.49 0 2.15-.66 2.15-2.15V2.75H3.75V14.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 2.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h20c.41 0 .75.34.75.75s-.34.75-.75.75H2zM7.33 22.34a.745.745 0 0 1 .34-1.01l3.58-1.79V17c0-.41.34-.75.75-.75s.75.34.75.75v3c0 .28-.16.54-.42.67l-4 2a.742.742 0 0 1-1-.33z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.67 22.67-4-2a.763.763 0 0 1-.34-1.01c.19-.37.64-.52 1.01-.34l4 2c.37.19.52.64.34 1.01a.77.77 0 0 1-.68.42c-.11 0-.23-.03-.33-.08zM6.92 11.48a.75.75 0 0 1 .1-1.06l3.15-2.63c.29-.24.66-.34 1.01-.28.36.06.67.28.86.6l1.05 1.75 2.93-2.44c.32-.26.79-.22 1.06.1s.22.79-.1 1.06l-3.15 2.63c-.29.24-.66.34-1.01.28-.36-.06-.67-.28-.86-.6l-1.05-1.75-2.93 2.44a.759.759 0 0 1-1.06-.1z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlinePresentionChart);
export default __webpack_public_path__ + "static/media/vuesax-outline-presention-chart.5a659667e9ea515d7f81b146807b33ab.svg";
export { ForwardRef as ReactComponent };